"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _ReviewedDocumentContext = require("../context/ReviewedDocumentContext");
var _PageContext = require("../context/PageContext");
var _rules = require("../utils/rules");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var RecentRunsPage = function RecentRunsPage() {
  var _useReviewedDocument = (0, _ReviewedDocumentContext.useReviewedDocument)(),
    reviewSummaries = _useReviewedDocument.reviewSummaries,
    applyActiveReview = _useReviewedDocument.applyActiveReview;
  var _usePage = (0, _PageContext.usePage)(),
    showPage = _usePage.showPage;
  var sortedReviewSummaries = (0, _react.useMemo)(function () {
    return _toConsumableArray(reviewSummaries).sort(function (a, b) {
      var dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      var dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
      return dateB - dateA;
    });
  }, [JSON.stringify(reviewSummaries)]);
  var groupedRuns = (0, _react.useMemo)(function () {
    var groups = {};
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    sortedReviewSummaries.forEach(function (review) {
      if (!review.createdAt) return;
      var reviewDate = new Date(review.createdAt);
      reviewDate.setHours(0, 0, 0, 0);
      var groupKey;
      if (reviewDate.getTime() === today.getTime()) {
        groupKey = "Today";
      } else {
        groupKey = reviewDate.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      }
      if (!groups[groupKey]) {
        groups[groupKey] = [];
      }
      groups[groupKey].push(review);
    });
    return Object.entries(groups);
  }, [sortedReviewSummaries]);
  var handleRunClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(reviewId) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return applyActiveReview(reviewId);
          case 1:
            showPage(_PageContext.PAGES.documentReviewPage);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleRunClick(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var handleBack = function handleBack() {
    showPage(_PageContext.PAGES.submitDocumentPage);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "w-full h-full bg-white flex flex-col gap-4 p-4",
    "data-sentry-component": "RecentRunsPage",
    "data-sentry-source-file": "RecentRunsPage.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex gap-2 items-center sticky top-0 w-full",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: handleBack,
        className: "block cursor-pointer overflow-clip relative shrink-0 size-6 border-none bg-transparent p-0",
        "aria-label": "Go back",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronLeftIcon, {
          width: 24,
          height: 24,
          fill: "#171715",
          "data-sentry-element": "ChevronLeftIcon",
          "data-sentry-source-file": "RecentRunsPage.tsx"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
        className: "flex-1 font-semibold text-[20px] leading-[1.4] text-[#3D3D3D] m-0",
        children: "Recent Runs"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "flex-1 overflow-y-auto overflow-x-hidden",
      children: groupedRuns.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "text-center p-6 text-sm text-[#6B7280]",
        children: "No recent runs found"
      }) : groupedRuns.map(function (_ref2, groupIndex) {
        var _ref3 = _slicedToArray(_ref2, 2),
          dateLabel = _ref3[0],
          runs = _ref3[1];
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [groupIndex > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "h-2 my-2"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "font-normal text-xs leading-[1.2] tracking-[0.48px] text-[#686766] mb-2",
            children: dateLabel
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "flex flex-col",
            children: runs.map(function (review) {
              var _review$playbooks;
              var isReportReady = review.isReportDone && review.reviewReport && review.reviewReport.length > 0;
              var riskScore = isReportReady ? (0, _rules.calculateRiskScore)(review.reviewReport) : 0;
              var title = ((_review$playbooks = review.playbooks) === null || _review$playbooks === void 0 || (_review$playbooks = _review$playbooks[0]) === null || _review$playbooks === void 0 ? void 0 : _review$playbooks.name) || 'Untitled run';
              var radius = 10;
              var circumference = 2 * Math.PI * radius;
              var dashOffset = circumference * (1 - (isReportReady ? 100 - riskScore : 100) / 100);
              return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                onClick: function onClick() {
                  return handleRunClick(review.id);
                },
                className: "box-border flex flex-row items-center p-4 gap-[10px] w-full h-16 bg-white border-l-4 border-primary mb-2 cursor-pointer hover:bg-[#F8F8F8]",
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: "flex flex-col items-start gap-1 flex-grow",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    title: title,
                    className: "font-normal text-base leading-[150%] tracking-[0.16px] text-[#171715] overflow-hidden text-ellipsis whitespace-nowrap w-full",
                    children: title
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-row items-start gap-[10px] w-full",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      className: "relative w-6 h-6 flex-shrink-0",
                      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
                        viewBox: "0 0 24 24",
                        "aria-hidden": "true",
                        className: "w-full h-full -rotate-90",
                        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                          cx: "12",
                          cy: "12",
                          r: radius,
                          fill: "none",
                          stroke: "#D4D3D0",
                          strokeWidth: "3"
                        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                          cx: "12",
                          cy: "12",
                          r: radius,
                          fill: "none",
                          stroke: "var(--primary)",
                          strokeWidth: "3",
                          strokeLinecap: "round",
                          style: {
                            strokeDasharray: circumference,
                            strokeDashoffset: dashOffset
                          }
                        })]
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                      className: "font-normal text-base leading-[150%] tracking-[0.16px] text-[#888786] flex-grow whitespace-nowrap",
                      children: ["Risk Score: ", !isReportReady ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                        className: "font-semibold",
                        children: "N/A"
                      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                        className: "font-semibold",
                        children: [riskScore, "%"]
                      })]
                    })]
                  })]
                })
              }, review.id);
            })
          })]
        }, dateLabel);
      })
    })]
  });
};
var _default = exports.default = RecentRunsPage;